const attribute = 'data-positive-nav';
// Share ownership across development instances and independently loaded CDN scripts.
const targetState = Symbol.for('positive-nav.target-marker');

function renderMarker(target, record) {
  const positions = new Set(record.positions.values());
  const position = positions.has('fixed') ? 'fixed': positions.has('sticky') ? 'sticky': 'relative';
  if (target.getAttribute(attribute) !== position) target.setAttribute(attribute, position);
}

/** Track the target marker through controller calls, without observing the DOM. */
export function createTargetMarker() {
  const owner = {};
  let currentTarget;

  function dispose() {
    if (!currentTarget) return;
    const target = currentTarget;
    currentTarget = undefined;
    const record = target[targetState];
    record.positions.delete(owner);
    if (record.positions.size) {
      renderMarker(target, record);
    } else {
      delete target[targetState];
      if (record.previous === null) target.removeAttribute(attribute);
      else target.setAttribute(attribute, record.previous);
    }
  }

  return {
    update(target, position) {
      if (currentTarget !== target) {
        dispose();
        currentTarget = target;
      }
      let record = target[targetState];
      if (!record) {
        record = { previous: target.getAttribute(attribute), positions: new Map() };
        Object.defineProperty(target, targetState, { configurable: true, value: record });
      }
      record.positions.set(owner, position);
      renderMarker(target, record);
    },
    dispose,
  };
}
